<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <title>Cerca</title>
    <path
      d="M9.769.31h0c2.691 0 5.128 1.1 6.896 2.868a9.71 9.71 0 0 1 2.849 6.896h0c0 1.081-.177 2.122-.511 3.104l-.177.471h0c-.275.707-.648 1.395-1.081 2.004l5.678 5.108h0l.039.039h0a1.7 1.7 0 0 1 .511 1.139c.02.432-.118.845-.393 1.159h0l-.039.039h0l-.02.039h0c-.314.334-.707.491-1.12.511s-.825-.098-1.159-.393h0l-.039-.039h0l-5.795-5.226-.53.354-.747.413a9.81 9.81 0 0 1-4.342 1.022h0c-2.691 0-5.128-1.1-6.896-2.868C1.125 15.201.025 12.765.025 10.074h0c0-2.692 1.1-5.128 2.849-6.896C4.642 1.41 7.078.31 9.769.31h0zm0 2.18h0c-2.082 0-3.968.845-5.344 2.22s-2.22 3.261-2.22 5.344h0c0 2.082.845 3.968 2.22 5.344s3.261 2.22 5.344 2.22h0c2.082 0 3.968-.845 5.344-2.22s2.22-3.261 2.22-5.344h0c0-2.082-.845-3.968-2.22-5.344-1.414-1.414-3.34-2.22-5.344-2.22h0z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {};
</script>
